var __defProp = Object.defineProperty,
  __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty,
  __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value
  }) : obj[key] = value,
  __spreadValues = (a, b) => {
    for (var prop in b || (b = {})) __hasOwnProp.call(b, prop) && __defNormalProp(a, prop, b[prop]);
    if (__getOwnPropSymbols) for (var prop of __getOwnPropSymbols(b)) __propIsEnum.call(b, prop) && __defNormalProp(a, prop, b[prop]);
    return a;
  },
  __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source) __hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0 && (target[prop] = source[prop]);
  if (source != null && __getOwnPropSymbols) for (var prop of __getOwnPropSymbols(source)) exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop) && (target[prop] = source[prop]);
  return target;
};
import * as React from "react";
import { Text } from "@twilio-paste/text";
import { useUID } from "@twilio-paste/uid-library";
import { Box, safelySpreadBoxProps } from "@twilio-paste/box";
import { SiblingBox } from "@twilio-paste/sibling-box";
var FilePicker = React.forwardRef((_a, ref) => {
  var _b = _a,
    {
      element = "FILEPICKER",
      accept,
      id = useUID(),
      children,
      disabled = !1,
      i18nNoSelectionText = "No file uploaded",
      required = !1,
      onChange
    } = _b,
    props = __objRest(_b, ["element", "accept", "id", "children", "disabled", "i18nNoSelectionText", "required", "onChange"]);
  let [fileDescription, setFileDescription] = React.useState(i18nNoSelectionText),
    textId = useUID(),
    handleChange = evt => {
      if (onChange && onChange(evt), evt.currentTarget.files && evt.currentTarget.files.length > 0) {
        let file = evt.currentTarget.files[0].name;
        setFileDescription(file);
      } else setFileDescription(i18nNoSelectionText);
    };
  return React.createElement(React.Fragment, null, React.createElement(Box, __spreadProps(__spreadValues({}, safelySpreadBoxProps(props)), {
    id,
    ref,
    as: "input",
    type: "file",
    accept,
    "aria-disabled": disabled,
    disabled,
    "aria-required": required,
    "aria-describedby": textId,
    size: "size0",
    border: "none",
    overflow: "hidden",
    padding: "space0",
    margin: "space0",
    whiteSpace: "nowrap",
    textTransform: "none",
    position: "absolute",
    clip: "rect(0 0 0 0)",
    onChange: handleChange
  })), React.createElement("label", {
    htmlFor: id
  }, React.createElement(SiblingBox, {
    element,
    as: "span",
    type: "file",
    borderRadius: "borderRadius10",
    padding: "space20",
    paddingLeft: "space30",
    boxShadow: "shadowBorderWeak",
    _focusSibling: {
      borderRadius: "borderRadius10",
      padding: "space20",
      paddingLeft: "space30",
      boxShadow: "shadowFocus"
    }
  }, React.createElement(Text, {
    id: textId,
    as: "span",
    color: disabled ? "colorTextWeaker" : "currentColor",
    marginRight: "space40",
    fontWeight: "fontWeightMedium",
    element: `${element}_TEXT`
  }, fileDescription), React.cloneElement(children, {
    disabled,
    element: `${element}_BUTTON`
  }))));
});
FilePicker.displayName = "FilePicker";
import * as React2 from "react";
import PropTypes2 from "prop-types";
import { Button } from "@twilio-paste/button";
import { Box as Box2 } from "@twilio-paste/box";
var FilePickerButton = React2.forwardRef((_a, ref) => {
  var _b = _a,
    {
      children,
      element,
      disabled
    } = _b,
    props = __objRest(_b, ["children", "element", "disabled"]);
  return React2.createElement(Box2, {
    whiteSpace: "nowrap"
  }, React2.createElement(Button, __spreadProps(__spreadValues({}, props), {
    element,
    ref,
    size: "small",
    disabled,
    as: "span",
    type: "button"
  }), children));
});
FilePickerButton.displayName = "FilePickerButton";
FilePickerButton.propTypes = {
  element: PropTypes2.string,
  children: PropTypes2.node.isRequired,
  disabled: PropTypes2.bool
};
export { FilePicker, FilePickerButton };